import React, { useEffect, useRef } from 'react';

const SUMMARY_BOX_TAG = 'ce-ai-components-summary-box';

const SHADOW_SPACING_CSS = `
    .summary-box { gap: 5px !important; }
    .summary-box .content h3 { margin: 5px 0 4px 0 !important; }
    .summary-box .content p { margin: 0 0 4px 0 !important; }
    .summary-box .content ul { margin: 0 0 4px 0 !important; padding-left: 20px !important; }
    .summary-box .content li { margin-bottom: 2px !important; }
`;

function AiSummaryBox({ containerId, onSummaryRequested }) {
    const onSummaryRequestedRef = useRef(onSummaryRequested);

    useEffect(() => {
        onSummaryRequestedRef.current = onSummaryRequested;
    }, [onSummaryRequested]);

    useEffect(() => {
        const container = document.getElementById(containerId);
        if (container) {
            container.innerHTML = '';
            container.appendChild(document.createElement(SUMMARY_BOX_TAG));
        }

        let polls = 0;
        const MAX_POLLS = 200; // 10 seconds at 50ms intervals
        const initInterval = setInterval(() => {
            if (++polls > MAX_POLLS) {
                clearInterval(initInterval);
                return;
            }
            const summaryElement = document.querySelector(`#${CSS.escape(containerId)} ${SUMMARY_BOX_TAG}`);
            if (!summaryElement?.actions) return;

            clearInterval(initInterval);

            if (summaryElement.shadowRoot) {
                const sheet = new CSSStyleSheet();
                sheet.replaceSync(SHADOW_SPACING_CSS);
                try {
                    summaryElement.shadowRoot.adoptedStyleSheets = [
                        ...(summaryElement.shadowRoot.adoptedStyleSheets ?? []),
                        sheet,
                    ];
                } catch (_) {
                    // Constructable Stylesheets not supported; spacing styles skipped, initialization continues
                }
            }

            summaryElement.actions.initialize({
                aiResponseRequested: () => onSummaryRequestedRef.current(),
                cancelClicked: () => {},
                disclaimer: {
                    referenceLabel: 'Reference',
                    employmentOrHiringDecisionsLabel: 'Employment or Hiring Decisions',
                },
                generateButton: {
                    generateLabel: 'Generate',
                    regenerateLabel: 'Regenerate',
                },
                label: {
                    empty: 'Generate Summary',
                    generated: 'Summary',
                    loading: 'Generating summary...',
                    error: 'Failed to generate summary',
                },
                autId: containerId,
            });
        }, 50);

        return () => clearInterval(initInterval);
    }, [containerId]);

    return <div id={containerId} />;
}

export default AiSummaryBox;
